/**Tipi di controllo */
export enum matchVal {
    /**valido per string */
    like = "LIKE",
    /**valido per string */
    notLike = "NOT_LIKE",
    /**valido per string, number, date e boolean */
    equals = "EQUALS",
    /**valido per string, number, date e boolean */
    notEquals = "NOT_EQUALS",
    /**valido per number e date */
    greaterThan = "GREATER_THAN",
    /**valido per number e date */
    greaterThanOrEquals = "GREATER_THAN_OR_EQUALS",
    /**valido per number e date */
    lessThan = "LESS_THAN",
    /**valido per number e date */
    lessThanOrEquals = "LESS_THAN_OR_EQUALS"
}

/**Opzioni di controllo, attive solo se match è LIKE */
export enum matchOptionsVal {
    /**Case sensitive */
    matchcase = "MATCH_CASE",
    /**parola esatta */
    wholeWord = "WHOLE_WORD",
    /**inizia con */
    startsWith = "STARTS_WITH",
    /**finisce con */
    endsWith = "ENDS_WITH"
}

/**Interfaccia per i filtri singoli */
export interface SingleFilter {
    /**nome del campo a cui applicare il fitro */
    field: string;
    /**valore da ricercare nel campo */
    value: string;
    /**tipo di controllo */
    match: matchVal;
    /**opzioni di controllo */
    matchOptions: matchOptionsVal[];
}